import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  P500UIButtonsModule,
  P500UIDropdownModule,
  P500UIFormFieldsModule,
  P500UIIconsModule,
  P500UIManyItemsModule,
  P500UIPipesModule,
  P500UITooltipModule,
} from '@platform500services/p500-ui-kit';
import { ActionButtonModule } from '../../directives/action-button/action-button.module';
import { AffiliatesSelectComponent } from './default/affiliates-select/affiliates-select.component';
import { BooleanComponent } from './default/boolean/boolean.component';
import { CountriesSelectComponent } from './default/countries-select/countries-select.component';
import { CountriesComponent } from './default/countries/countries.component';
import { CountryComponent } from './default/country/country.component';
import { DatetimeComponent } from './default/datetime/datetime.component';
import { DefaultEmptyComponent } from './default/empty/default-empty.component';
import { LinkComponent } from './default/link/link.component';
import { ManyItemsComponent } from './default/many-items/many-items.component';
import { MoneyComponent } from './default/money/money.component';
import { StatusComponent } from './default/status/status.component';
import { StringOrDefaultComponent } from './default/string-or-default/string-or-default.component';
import { StringOrEmptyComponent } from './default/string-or-empty/string-or-empty.component';
import { StringWhitespaceOrEmptyWithCopyComponent } from './default/string-whitespace-or-empty-with-copy/string-whitespace-or-empty-with-copy.component';
import { StringWhitespaceOrEmptyComponent } from './default/string-whitespace-or-empty/string-whitespace-or-empty.component';
import { StringComponent } from './default/string/string.component';
import { DynamicComponent } from './dynamic/dynamic/dynamic.component';
import { InvoiceStatusComponent } from './default/invoice-status/invoice-status.component';
import { CurrencyComponent } from './default/currency/currency.component';
import { ConversionTrackingTypeComponent } from './special/conversion-tracking-type/conversion-tracking-type.component';
import { AffiliatesTrackersTypeComponent } from './special/affiliates-trackers-type/affiliates-trackers-type.component';
import { AffiliatePdfComponent } from './special/affiliate-pdf/affiliate-pdf.component';
import { GetSmartLinkComponent } from './special/get-smart-link/get-smart-link.component';
import { GoalPayoutTypeComponent } from './special/goal-payout-type/goal-payout-type.component';
import { GoalRevenueTypeComponent } from './special/goal-revenue-type/goal-revenue-type.component';
import { PayoutModelComponent } from './special/payout-model/payout-model.component';
import { BusinessFormatComponent } from './special/business-format/business-format.component';
import { LanguageComponent } from './default/language/language.component';
import { CountryViewComponent } from './default/country-view/country-view.component';
import { CellWithLabelComponent } from './special/cell-with-label/cell-with-label.component';
import { ImagePreviewComponent } from './special/image-preview/image-preview.component';
import { OsWithIconComponent } from './special/os-with-icon/os-with-icon.component';
import { ImageUploaderComponent } from './default/image-uploader/image-uploader.component';
import { NumberStatusComponent } from './default/number-status/number-status.component';
import { LanguagesComponent } from './default/languages/languages.component';
import { CrmCurrencyComponent } from './default/crm-currency/crm-currency.component';
import { NumberComponent } from './default/number/number.component';
import { FinanceInvoiceStatusComponent } from './default/finance-invoice-status/finance-invoice-status.component';
import { AttachmentsComponent } from './special/attachments/attachments.component';
import { EarningStatusComponent } from './default/earning-status/earning-status.component';
import { FinancePaymentStatusComponent } from './default/finance-payment-status/finance-payment-status.component';
import { PaymentMethodStatusComponent } from './default/payment-method-status/payment-method-status.component';
import { ProtectedFieldComponent } from './default/protected/protected.component';
import { CountryShortComponent } from './default/country-short/country-short.component';
import { OfferPayoutModelsComponent } from './special/offer-payout-models/offer-payout-models.component';
import { RegionComponent } from './default/region/region.component';
import { CountryRegionComponent } from './default/country-region/country-region.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RemovePrefixPipe } from './default/country-region/remove-prefix.pipe';
import { OfferPayoutModelsToProfileComponent } from './special/offer-payout-models/offer-payout-models-to-profile.component';
import { LinksComponent } from './default/links/links.component';
import { MoneyWithCurrencyComponent } from './special/money-with-currency/money-with-currency.component';
import { ComparingAnalyticsDifferenceTypeComponent } from './special/comparing-analytics-difference-type/comparing-analytics-difference-type.component';
import { ComparingNumberComponent } from './special/comparing-number/comparing-number.component';
import { ComparingPercentageComponent } from './special/comparing-percentage/comparing-percentage.component';
import { TermsFormatComponent } from './default/terms-format/terms-format.component';
import { NumberFormatPipe } from '../../pipes/number-format/number-format.pipe';
import { CrmPercentComponent } from './default/crm-percent/crm-percent.component';
import { BitcoinFormatPipe } from '../../pipes/bitcoin-format/bitcoin-format';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    P500UIButtonsModule,
    P500UIIconsModule,
    P500UITooltipModule,
    P500UIPipesModule,
    RouterModule,
    P500UIFormFieldsModule,
    ActionButtonModule,
    P500UIDropdownModule,
    P500UIManyItemsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NumberFormatPipe,
    BitcoinFormatPipe,
  ],
  declarations: [
    DynamicComponent,
    StringComponent,
    StringOrEmptyComponent,
    StringOrDefaultComponent,
    BooleanComponent,
    DatetimeComponent,
    MoneyComponent,
    DefaultEmptyComponent,
    LinkComponent,
    LinksComponent,
    StringWhitespaceOrEmptyComponent,
    ManyItemsComponent,
    CountryComponent,
    CountriesComponent,
    CountriesSelectComponent,
    AffiliatesSelectComponent,
    StringWhitespaceOrEmptyWithCopyComponent,
    StatusComponent,
    InvoiceStatusComponent,
    CurrencyComponent,
    ConversionTrackingTypeComponent,
    AffiliatesTrackersTypeComponent,
    AffiliatePdfComponent,
    GetSmartLinkComponent,
    GoalPayoutTypeComponent,
    GoalRevenueTypeComponent,
    PayoutModelComponent,
    BusinessFormatComponent,
    LanguageComponent,
    CountryViewComponent,
    CellWithLabelComponent,
    ImagePreviewComponent,
    OsWithIconComponent,
    ImageUploaderComponent,
    NumberStatusComponent,
    LanguagesComponent,
    CrmCurrencyComponent,
    NumberComponent,
    FinanceInvoiceStatusComponent,
    FinancePaymentStatusComponent,
    EarningStatusComponent,
    AttachmentsComponent,
    PaymentMethodStatusComponent,
    ProtectedFieldComponent,
    CountryShortComponent,
    OfferPayoutModelsComponent,
    RegionComponent,
    CountryRegionComponent,
    RemovePrefixPipe,
    OfferPayoutModelsToProfileComponent,
    MoneyWithCurrencyComponent,
    ComparingAnalyticsDifferenceTypeComponent,
    ComparingNumberComponent,
    ComparingPercentageComponent,
    TermsFormatComponent,
    CrmPercentComponent,
  ],
  exports: [
    DynamicComponent,
    StringComponent,
    StringOrEmptyComponent,
    StringOrDefaultComponent,
    BooleanComponent,
    DatetimeComponent,
    MoneyComponent,
    DefaultEmptyComponent,
    LinkComponent,
    LinksComponent,
    StringWhitespaceOrEmptyComponent,
    ManyItemsComponent,
    CountryComponent,
    CountriesComponent,
    CountriesSelectComponent,
    AffiliatesSelectComponent,
    StringWhitespaceOrEmptyWithCopyComponent,
    StatusComponent,
    InvoiceStatusComponent,
    CurrencyComponent,
    ConversionTrackingTypeComponent,
    AffiliatesTrackersTypeComponent,
    AffiliatePdfComponent,
    GetSmartLinkComponent,
    GoalPayoutTypeComponent,
    GoalRevenueTypeComponent,
    PayoutModelComponent,
    BusinessFormatComponent,
    LanguageComponent,
    CountryViewComponent,
    CellWithLabelComponent,
    ImagePreviewComponent,
    OsWithIconComponent,
    ImageUploaderComponent,
    NumberStatusComponent,
    LanguagesComponent,
    CrmCurrencyComponent,
    NumberComponent,
    FinanceInvoiceStatusComponent,
    FinancePaymentStatusComponent,
    EarningStatusComponent,
    AttachmentsComponent,
    PaymentMethodStatusComponent,
    ProtectedFieldComponent,
    CountryShortComponent,
    OfferPayoutModelsComponent,
    RegionComponent,
    CountryRegionComponent,
    OfferPayoutModelsToProfileComponent,
    ComparingAnalyticsDifferenceTypeComponent,
    ComparingNumberComponent,
    ComparingPercentageComponent,
    TermsFormatComponent,
    CrmPercentComponent,
  ],
})
export class FieldsModule {}
